export {
    createAlignmentTilePayload,
    isAlignmentTilePayload,
    POSITION_ALIGNMENT_AUTOMATION_TILE_TYPE,
    POSITION_ALIGNMENT_COMPARE_TILE_TYPE,
    POSITION_ALIGNMENT_NEW_TASK_TILE_TYPE,
    POSITION_ALIGNMENT_TASK_TILE_TYPE,
    POSITION_ALIGNMENT_TILE_TYPE,
} from './alignment-tile-payload';
export { useHasUnsavedCopyEdits } from './api/unsaved-copy-edits';
export { UnsavedEditsHint } from './components/UnsavedEditsHint';
export { positionAlignmentRoute } from './route';
export { positionAlignmentUrlTileModule, renderAlignmentCommentTile } from './url-tile';

export const loadMyAlignmentPage = async () => {
    const { MyAlignmentPage } = await import('./MyAlignmentPage');

    return { Component: MyAlignmentPage };
};

export const loadTeamAlignmentPage = async () => {
    const { TeamAlignmentPage } = await import('./TeamAlignmentPage');

    return { Component: TeamAlignmentPage };
};

export { useAlignment, useHasTeam, useMyAlignment } from './api/use-alignment-queries';
export { StepBadge } from './components/StepBadge';
export type { StepMark } from './model/stepper';
export { stepMark, stepStateOf } from './model/stepper';
export { useShortDate } from './model/use-short-date';
